import React, { useState } from "react";

import { useCheckAnalytics } from "../../apiHooks/common";
import BlogsPage from "../../components/blogs";
import MainBlog from "../../components/blogs/mainBlogHero";

export default function HomePage() {
  // eslint-disable-next-line no-empty-pattern
  const {} = useCheckAnalytics(
    {
      action: "home_page",
      extraReferrer: document.referrer,
    },
    true
  );
  return (
    <>
      <MainBlog />
      <BlogsPage />
    </>
  );
}
